module.exports = __webpack_public_path__ + "static/media/shape_arctic-first.b10f8f81.svg";